module.exports = __webpack_public_path__ + "public/images/reviews/review-veronika.a4d6c5e02766ce0dcd9145088a181e0c.png";